import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchMasterRaking, createMasterRaking, updateMasterRaking } from "./masterRakingSlice";
import { fetchMasterProducts } from "./masterProductsSlice";
import { fetchMasterWarehouses } from "./warehouseSlice";
import { useReactToPrint } from "react-to-print";
import PrintLabels from "./PrintLabels";
import { QRCodeCanvas } from "qrcode.react";
import moment from "moment";
import "moment/locale/id";
import PrintLevelLabels from "./PrintLevelLabels";
import { toast } from "react-toastify";

moment.locale("id");


export default function MasterRakingPage() {
    const dispatch = useDispatch();
    const printRef = useRef();

    const [openModal, setOpenModal] = useState(false);
    const masterRaking = useSelector((state) => state.masterRaking);
    const masterProducts = useSelector((state) => state.masterProducts);
    const masterWarehouses = useSelector((state) => state.masterWarehouses);
    const [printData, setPrintData] = useState([]);
    const [printMode, setPrintMode] = useState("multi"); 
    const [selectedIds, setSelectedIds] = useState([]);
    const pagination = masterRaking?.pagination || {};

    const [openDetail, setOpenDetail] = useState(false);
    const [selectedRack, setSelectedRack] = useState(null);

    const [isEdit, setIsEdit] = useState(false);
    const [editId, setEditId] = useState(null);

    const [openLevelQR, setOpenLevelQR] = useState(false);
    const [levelData, setLevelData] = useState([]);
    const [productSearch, setProductSearch] = useState("");

    const levelPrintRef = useRef();

    const generateLevelQR = (rack) => {
        const rows = rack.total_rows || 0;
        const columns = rack.total_columns || 0;

        let result = [];

        for (let r = 1; r <= rows; r++) {
            for (let c = 1; c <= columns; c++) {
                result.push({
                    code: `${rack.racks_name} ${r}.${c}`,
                    rack_name: rack.racks_name,
                    warehouse: rack.warehouse?.name
                });
            }
        }

        setLevelData(result);
        setOpenLevelQR(true);
    };

    const handlePrint = useReactToPrint({
        contentRef: printRef,
        documentTitle: "QR Labels",
        pageStyle: `
      @page {
        size: 101mm 53mm;
        margin: 0;
      }
      body {
        margin: 0;
      }
    `,
    });

    const handlePrintClick = async () => {
        if (printMode === "multi") {
            const res = await dispatch(fetchMasterRaking({
                ...filters,
                page: 1,
                per_page: 1000, // ambil semua
            })).unwrap();

            setPrintData(res.data); // simpan ke state khusus print
        } else {
            setPrintData(
                data.filter((item) => selectedIds.includes(item.id))
            );
        }

        setTimeout(() => {
            handlePrint();
        }, 300);
    };

    const handlePrintLevel = useReactToPrint({
        contentRef: levelPrintRef,
        documentTitle: "QR Level",
        pageStyle: `
      @page {
        size: 101mm 53mm;
        margin: 0;
      }
      body {
        margin: 0;
      }
    `,
    });

    const data = masterRaking?.data || [];
    const products = masterProducts?.data || [];
    const warehouses = masterWarehouses?.data || [];

    const loading = masterRaking?.loading || false;

    const [filters, setFilters] = useState({
        search: "",
        page: 1,
        per_page: 12,
    });

    const [form, setForm] = useState({
        code: "",
        bins_name: "",
        total_rows: "",
        total_columns: "",
        total_capacity: "",
        warehouse_id: null,
        product_ids: [],
    });

    /*const handleSubmit = async (e) => {
        e.preventDefault();

        if (!form.code || !form.bins_name) {
            toast.error("Semua field wajib diisi");
            return;
        }

        if (!form.product_ids || form.product_ids.length === 0) {
            toast.error("Pilih minimal 1 produk");
            return;
        }

        try {
            const res = await dispatch(createMasterRaking(form)).unwrap();

            toast.success(res?.message || "Data berhasil disimpan");

            setForm({
                code: "",
                bins_name: "",
                warehouse_id: null,
                product_ids: [],
            });

            dispatch(fetchMasterRaking(filters));

        } catch (err) {
            if (err?.message && typeof err.message === "object") {
                const errors = Object.values(err.message)
                    .flat()
                    .join("\n");

                toast.error(errors);
            } else if (err?.message) {
                toast.error(err.message);
            } else {
                toast.error("Gagal tambah data");
            }
        }
    };*/

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!form.code || !form.bins_name) {
            toast.error("Semua field wajib diisi");
            return;
        }

        if (!form.product_ids || form.product_ids.length === 0) {
            toast.error("Pilih minimal 1 produk");
            return;
        }

        try {
            let res;

            if (isEdit) {
                res = await dispatch(updateMasterRaking({
                    id: editId,
                    ...form
                })).unwrap();
            } else {
                res = await dispatch(createMasterRaking(form)).unwrap();
            }

            toast.success(res?.message || "Berhasil disimpan");

            setForm({
                code: "",
                bins_name: "",
                total_rows: "",
                total_columns: "",
                total_capacity: "",
                warehouse_id: null,
                product_ids: [],
            });

            setIsEdit(false);
            setEditId(null);

            dispatch(fetchMasterRaking(filters));

        } catch (err) {
            if (err?.message && typeof err.message === "object") {
                const errors = Object.values(err.message)
                    .flat()
                    .join("\n");

                toast.error(errors);
            } else {
                toast.error(err?.message || "Gagal simpan data");
            }
        }
    };

    const groupedProducts = products.reduce((acc, product) => {
        const categoryName = product.categories?.name || "Tanpa Kategori";

        if (!acc[categoryName]) {
            acc[categoryName] = [];
        }

        acc[categoryName].push(product);

        return acc;
    }, {});

    const changePage = (page) => {
        setFilters((prev) => ({
            ...prev,
            page,
        }));
    };

    useEffect(() => {
        dispatch(fetchMasterRaking(filters));
        dispatch(fetchMasterProducts({
            page: 1,
            per_page: 1000, 
        }));
        dispatch(fetchMasterWarehouses());
    }, [dispatch, filters]);

    const filteredGroupedProducts = Object.entries(groupedProducts).reduce(
        (acc, [category, items]) => {
            const filtered = items.filter(
                (product) =>
                    product.name
                        ?.toLowerCase()
                        .includes(productSearch.toLowerCase()) ||
                    product.sku
                        ?.toLowerCase()
                        .includes(productSearch.toLowerCase())
            );

            if (filtered.length > 0) {
                acc[category] = filtered;
            }

            return acc;
        },
        {}
    );

    return (
        <div className="p-6 space-y-6">
            <h1 className="text-2xl font-bold mb-4 no-print print:hidden">Master RAK</h1>

            <div className="bg-white p-4 rounded shadow no-print print:hidden">
                <button
                    onClick={() => setOpenModal(true)}
                    className="px-4 py-2 bg-green-500 text-white rounded"
                >
                    Tambah RAK
                </button>
            </div>

            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 mb-4 no-print print:hidden">
                <input
                    type="text"
                    placeholder="Search..."
                    className="flex-1 border px-3 py-2 rounded"
                    value={filters.search}
                    onChange={(e) =>
                        setFilters({ ...filters, search: e.target.value, page: 1 })
                    }
                />

                {/*<button
                    onClick={() => window.print()}
                    className="px-4 py-2 bg-blue-500 text-white rounded whitespace-nowrap"
                >
                    Print QR
                </button>*/}

                <div className="flex items-center gap-4 mb-2">
                    <label className="flex items-center gap-1">
                        <input
                            type="radio"
                            value="multi"
                            checked={printMode === "multi"}
                            onChange={() => setPrintMode("multi")}
                        />
                        Cetak Semua
                    </label>

                    <label className="flex items-center gap-1">
                        <input
                            type="radio"
                            value="single"
                            checked={printMode === "single"}
                            onChange={() => setPrintMode("single")}
                        />
                        Pilih
                    </label>
                </div>

                <div>
                    <button className="px-4 py-2 bg-blue-500 text-white rounded" onClick={handlePrintClick}>
                        Print QR
                    </button>

                    {/* hidden area for printing */}
                    <div style={{ position: "absolute", left: "-9999px", top: 0 }}>
                        <PrintLabels
                            ref={printRef}
                            data={printData}
                        />
                    </div>
                </div>
            </div>

            <div className="bg-white shadow overflow-hidden print:shadow-none print:bg-transparent">
                <div className="grid grid-cols-4 gap-4 p-4 print:p-0">
                    {data.map((item) => (
                        <div className="page" key={item.id}>
                            <div className="border border-gray-200 p-2">

                                <div className="flex items-center">

                                    {printMode === "single" && (
                                        <input
                                            type="checkbox"
                                            className="mr-2"
                                            checked={selectedIds.includes(item.id)}
                                            onChange={(e) => {
                                                const checked = e.target.checked;

                                                setSelectedIds((prev) => {
                                                    if (checked) {
                                                        return [...prev, item.id];
                                                    } else {
                                                        return prev.filter((id) => id !== item.id);
                                                    }
                                                });
                                            }}
                                        />
                                    )}

                                    {/* QR */}
                                    <QRCodeCanvas value={item.code} size={120} />

                                    {/* Info */}
                                    <div className="ml-2 text-xs font-bold bg-white px-1 rounded text-right">
                                        <div>{item.code}</div>
                                        <div className="text-[10px] text-gray-500">
                                            {item?.racks_name}
                                        </div>
                                        <div className="text-[10px] text-gray-500">
                                            {item.warehouse?.name}
                                        </div>
                                        <div className="text-[10px] text-gray-500">
                                           Dimensi : {item?.total_rows}  x {item?.total_columns}
                                        </div>  
                                        <div className="text-[10px] text-gray-500">
                                            {item?.total_capacity} Capacity
                                        </div>  
                                        {/*<div className="text-[10px] text-gray-500">
                                            {item.products?.length || 0} Produk
                                        </div>*/}

                                        <button
                                            onClick={() => {
                                                setSelectedRack(item);
                                                setOpenDetail(true);
                                            }}
                                            className="text-blue-500 text-xs mt-1"
                                        >
                                            Lihat Produk
                                        </button>

                                        <button
                                            onClick={() => generateLevelQR(item)}
                                            className="text-purple-600 text-xs mt-1 ml-2"
                                        >
                                            QR Level
                                        </button>

                                        <button
                                            onClick={() => {
                                                setForm({
                                                    code: item.code,
                                                    bins_name: item.racks_name,
                                                    total_rows: item.total_rows,
                                                    total_columns: item.total_columns,
                                                    total_capacity: item.total_capacity,
                                                    warehouse_id: item.warehouse_id,
                                                    product_ids: item.products?.map(p => p.id) || []
                                                });

                                                setEditId(item.id);
                                                setIsEdit(true);
                                                setOpenModal(true);
                                            }}
                                            className="text-green-600 text-xs mt-1 ml-2"
                                        >
                                            Edit
                                        </button>
                                    </div>

                                </div>

                            </div>
                        </div>
                    ))}
                </div>
            </div>


            <div className="flex justify-between mt-4">
                <span>
                    Page {pagination?.current_page || 0} of {pagination?.last_page || 0}
                </span>

                <div className="flex gap-2">
                    <button
                        disabled={!pagination?.prev_page_url}
                        onClick={() => changePage(pagination.current_page - 1)}
                    >
                        Prev
                    </button>

                    <button
                        disabled={!pagination?.next_page_url}
                        onClick={() => changePage(pagination.current_page + 1)}
                    >
                        Next
                    </button>
                </div>

            </div>

            {openModal && (
                <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded shadow w-full max-w-md">
                        <h2 className="font-semibold mb-4">Tambah RAK</h2>

                        <form onSubmit={(e) => {
                            handleSubmit(e);
                            setOpenModal(false);
                        }} className="flex flex-col gap-3">

                            <input
                                type="text"
                                placeholder="Code"
                                value={form.code}
                                onChange={(e) =>
                                    setForm({ ...form, code: e.target.value })
                                }
                                className="border px-3 py-2 rounded"
                            />

                            <input
                                type="text"
                                placeholder="Rak Name"
                                value={form.bins_name}
                                onChange={(e) =>
                                    setForm({ ...form, bins_name: e.target.value })
                                }
                                className="border px-3 py-2 rounded"
                            />

                            <input
                                type="text"
                                placeholder="Total Rows"
                                value={form.total_rows}
                                onChange={(e) =>
                                    setForm({ ...form, total_rows: e.target.value })
                                }
                                className="border px-3 py-2 rounded"
                            />

                            <input
                                type="text"
                                placeholder="Total Columns"
                                value={form.total_columns}
                                onChange={(e) =>
                                    setForm({ ...form, total_columns: e.target.value })
                                }
                                className="border px-3 py-2 rounded"
                            />

                            <input
                                type="text"
                                placeholder="Total Capacity"
                                value={form.total_capacity}
                                onChange={(e) =>
                                    setForm({ ...form, total_capacity: e.target.value })
                                }
                                className="border px-3 py-2 rounded"
                            />

                            <select
                                value={form.warehouse_id || ""}
                                onChange={(e) =>
                                    setForm({ ...form, warehouse_id: e.target.value })
                                }
                                className="border px-3 py-2 rounded"
                            >
                                <option value="">Pilih Warehouse</option>

                                {warehouses.map((warehouse) => (
                                    <option key={warehouse.id} value={warehouse.id}>
                                        {warehouse.name}
                                    </option>
                                ))}
                            </select>

                            {/* TAMBAHAN: pilih produk */}
                            <div className="border rounded p-3 max-h-60 overflow-y-auto space-y-3">
                                <input
                                    type="text"
                                    placeholder="Cari SKU / Nama Produk..."
                                    value={productSearch}
                                    onChange={(e) => setProductSearch(e.target.value)}
                                    className="border px-3 py-2 rounded w-full"
                                />

                                {Object.entries(filteredGroupedProducts).map(([category, items]) => (
                                    <div key={category}>

                                        {/* Header Category */}
                                        <div className="flex items-center justify-between mb-1">
                                            <span className="font-semibold text-sm text-gray-700">
                                                {category}
                                            </span>

                                            <input
                                                type="checkbox"
                                                onChange={(e) => {
                                                    if (e.target.checked) {
                                                        const ids = items.map((p) => p.id);
                                                        setForm({
                                                            ...form,
                                                            product_ids: [...new Set([...form.product_ids, ...ids])],
                                                        });
                                                    } else {
                                                        const ids = items.map((p) => p.id);
                                                        setForm({
                                                            ...form,
                                                            product_ids: form.product_ids.filter(
                                                                (id) => !ids.includes(id)
                                                            ),
                                                        });
                                                    }
                                                }}
                                            />
                                        </div>

                                        {/* List Product */}
                                        <div className="ml-2 space-y-1">
                                            {items.map((product) => (
                                                <label key={product.id} className="flex items-center gap-2 text-sm">
                                                    <input
                                                        type="checkbox"
                                                        checked={form.product_ids?.includes(product.id)}
                                                        onChange={(e) => {
                                                            if (e.target.checked) {
                                                                setForm({
                                                                    ...form,
                                                                    product_ids: [...form.product_ids, product.id],
                                                                });
                                                            } else {
                                                                setForm({
                                                                    ...form,
                                                                    product_ids: form.product_ids.filter(
                                                                        (id) => id !== product.id
                                                                    ),
                                                                });
                                                            }
                                                        }}
                                                    />
                                                    <span>{product.sku}</span>
                                                    <span>-</span>
                                                    <span>{product.name}</span>
                                                </label>
                                            ))}
                                        </div>

                                    </div>
                                ))}

                                {Object.keys(filteredGroupedProducts).length === 0 && (
                                    <div className="text-center text-gray-500 py-4">
                                        Produk tidak ditemukan
                                    </div>
                                )}

                            </div>

                            <div className="flex justify-end gap-2">
                                <button
                                    type="button"
                                    onClick={() => setOpenModal(false)}
                                    className="px-3 py-2 border rounded"
                                >
                                    Batal
                                </button>

                                <button
                                    type="submit"
                                    className="px-4 py-2 bg-green-500 text-white rounded"
                                >
                                    Simpan
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {openDetail && selectedRack && (
                <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
                    <div className="bg-white p-6 rounded w-full max-w-lg">

                        <h2 className="font-bold mb-3">
                            Produk di Rak {selectedRack.code}
                        </h2>

                        <div className="max-h-80 overflow-y-auto space-y-2">
                            {selectedRack.products?.map((p) => (
                                <div key={p.id} className="border-b pb-1 text-sm">
                                    <div className="font-semibold">{p.sku}</div>
                                    <div className="text-gray-600">{p.name}</div>
                                </div>
                            ))}
                        </div>

                        <div className="flex justify-end mt-4">
                            <button
                                onClick={() => setOpenDetail(false)}
                                className="px-3 py-2 border rounded"
                            >
                                Tutup
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {openLevelQR && (
                <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
                    <div className="bg-white p-6 rounded w-full max-w-4xl">

                        <h2 className="font-bold mb-4">
                            QR Per Level
                        </h2>

                        <div className="grid grid-cols-4 gap-4 max-h-[500px] overflow-y-auto">
                            {levelData.map((item, index) => (
                                <div key={index} className="print-item flex items-center p-2 relative border rounded text-right">

                                    <QRCodeCanvas value={item.code} size={100} />

                                    <div className="ml-2 text-xs font-bold bg-white px-1 rounded text-right">
                                        {item.code}
                                    </div>

                                </div>
                            ))}
                        </div>

                        <div className="flex justify-end mt-4 gap-2">
                            <button
                                onClick={() => setOpenLevelQR(false)}
                                className="px-3 py-2 border rounded"
                            >
                                Tutup
                            </button>

                            <button
                                onClick={handlePrintLevel}
                                className="px-4 py-2 bg-blue-500 text-white rounded"
                            >
                                Print
                            </button>
                        </div>

                        {/* Hidden print area */}
                        <div style={{ position: "absolute", left: "-9999px" }}>
                            <PrintLevelLabels
                                ref={levelPrintRef}
                                data={levelData}
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
